import { ReduxStore } from 'common/types/reduxStore';

export const getManagersEmployeesExpensesSelector = (state: ReduxStore) =>
  state.managersEmployeeExpensesReducer?.employeeExpenses;
export const getSelectedExpenseSelector = (state: ReduxStore) =>
  state.managersEmployeeExpensesReducer?.selectedExpense;
